import type { InputHTMLAttributes, Ref } from "react";

import { input } from "~/components/Input.css";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  ref?: Ref<HTMLInputElement>;
}

/**
 * Thin wrapper around a native <input>. Reads the token-driven style
 * and forwards every native prop: `type`, `value`, `onChange`,
 * `required`, `pattern`, `minLength`, `maxLength`, all the HTML5
 * constraint validation attributes, and `aria-*` for accessibility.
 *
 * Callers are expected to pair this with an <label htmlFor=...> for
 * accessibility. We intentionally do NOT bundle a label slot here:
 * Field composes a control with its label and message line for the
 * common form field pattern, and keeping them separate lets unusual
 * layouts opt out without fighting the primitive.
 */
export function Input({ className, ref, ...rest }: InputProps) {
  const merged =
    className !== undefined && className.length > 0
      ? `${input} ${className}`
      : input;
  return <input ref={ref} className={merged} {...rest} />;
}
